import React, { useContext, useState } from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { useLocation } from 'react-router-dom';

import { Link } from 'app/src/utils/routing';
import { elLightGray, elGray } from 'app/src/styles/colors';
import {
  LinkContainer,
  LinkSpace,
  SubNavContainer
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import AuthContext from 'app/src/contexts/AuthContext';

import NewSale from './new';
import ProxibidExport from './ProxibidExport';

// const NavbarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;
//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const TableNavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elGray};
  padding: 15px;
  padding-left: 15px;
`;

const TableType = styled(Text)`
  font-weight: ${props => props.current ? '800' : '400'}
`;

const SubNav = ({sale, refetch, tableType, setShowAchBatchModal}) => {
  const [showAddSaleModal, setShowAddSaleModal] = useState(false);
  const [showSaleBuyersModal, setShowSaleBuyersModal] = useState(false);
  const [showProxibidExport, setShowProxibidExport] = useState(false);

  const location = useLocation();
  const { hasPolicy } = useContext(AuthContext);

  return (
    <TableNavbarContainer style={{borderBottom: "solid"}}>
      {getLinks()}
      {showProxibidExport &&
        <Modal
          showModal={ProxibidExport}
          setShowModal={setShowProxibidExport}
          modalType="Proxibid Export"
        >
          <ProxibidExport sale={sale} setShowModal={setShowProxibidExport} />
        </Modal>
      }
    </TableNavbarContainer>
  )

  function getLinks() {
    if(location.pathname === '/sales') {
      if (!hasPolicy({ type: 'Sale', action: 'create' })) {
        return null;
      }

      return (
        <View style={{display: 'flex', flexDirection: 'row'}}>
          <Pressable
            onPress={() => setShowAddSaleModal(true)}
          >
            <Text>+ Add Sale</Text>
          </Pressable>
          {showAddSaleModal &&
            <Modal
              showModal={showAddSaleModal}
              setShowModal={setShowAddSaleModal}
              modalType={'Add Sale'}
            >
              <NewSale
                setShowModal={setShowAddSaleModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === '/sales/new') {
      return (
        <Link to={`/sales`}>
          <Text>Sales</Text>
        </Link>
      )
    }else if(location.pathname === '/sales/sales-people') {

    }else {
      return (
        <LinkContainer>
          <Link to={`/sales`}>
            <Text>Sales</Text>
          </Link>
          <LinkSpace />
          {hasPolicy({ type: 'Sale', action: 'update' }) && (
            <>
              <Link to={`/sales/${sale.id}/add-assets`}>
                <Text>+ Add an Asset</Text>
              </Link>
              <LinkSpace />
            </>
          )}
          {hasPolicy({ type: 'Sale', action: 'update' }) && (
            <>
              <Link to={`/sales/${sale.id}/buyer-sales`}>
                <Text>+ Sale Buyers</Text>
              </Link>
              <LinkSpace />
            </>
          )}
          <Link to={`/sales/${sale.id}/pre`}>
            <TableType current={'pre' === tableType}>Pre-Sale List</TableType>
          </Link>
          <LinkSpace />
          <Link to={`/sales/${sale.id}/live`}>
            <TableType current={'live' === tableType}>Live Sale</TableType>
          </Link>
          <LinkSpace />
          <Link to={`/sales/${sale.id}/post`}>
            <TableType current={'post' === tableType}>Post-sale List</TableType>
          </Link>
          <LinkSpace />
          <Link to={`/sales/${sale.id}/pre-bids`}>
            <Text>Pre-Bids</Text>
          </Link>
          <LinkSpace />
          <Link to={`/bidding/buyers/${sale.id}`}>
            <Text>Buyer Lot Views</Text>
          </Link>
          {'pre' === tableType && (
            <>
              <LinkSpace />
              <Pressable onPress={() => setShowProxibidExport(true)}>
                <Text>Proxibid Export</Text>
              </Pressable>
            </>
          )}
          <LinkSpace />
          <Pressable
            onPress={() => setShowAchBatchModal(true)}
          >
            <Text>Current ACH Batch</Text>
          </Pressable>
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
